export const businessContactInformation = {
  name: "Brodie Birkett",
  //   address: "",
  city: "Ontario, Canada",
  zip: "M4K 3T4",
  phone: "(647) 895-3857",
  email: "brodieb777@hotmail.com",
};
